import Quill from 'quill';
var icons = Quill.import('ui/icons');
icons['bold'] =  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M14.39,11.38H9.13v5.39H5.87V3.23h9.05V5.75H9.13V8.87h5.26Z" class="ql-fill"/></svg>';
icons['italic'] =  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.05,10.94,7.19,12.63l-.71,4.12H4.19L6.54,3.26H8.83L7.74,9.46,9.16,8l4.65-4.72h2.93l-6,6.08,3.79,7.41H12Z" class="ql-fill"/></svg>';
